<template>
<form class="form" role="form" method="POST" :action="action" novalidate>
    <input type="hidden" name="_token" :value="$csrfToken">


    <div v-if="tokenIsInvalid" class="alert alert-danger">
        Your login link has expired, enter your email address to get another.
    </div>

    <div v-if="emailSent" class="alert alert-success">
        We've just sent you an email – click the button in it to log in.
    </div>

    <div v-if="view == 'passwordless'">

        <div class="form-group" :class="$errors.email ? 'has-error' : ''">
            <label class="control-label" for="password">Email Address</label>
            <input type="email" name="email" class="form-control" placeholder="Email address" :value="$old['email']" required autofocus>

            <span v-if="$errors.email" class="help-block">
                <strong>{{ $errors.email[0] }}</strong>
            </span>
        </div>
        <div class="checkbox">
        </div>
        <div class="form-group">
            <button class="btn btn-primary btn-block btn-lg btn-signin" type="submit">Get sign in link</button>
        </div>

        <div class="text-center">
            <a href="#" @click.prevent="setLoginView('password')">Staff Login</a>
        </div>

    </div>
    <div v-else>
        <div class="form-group" :class="$errors.email ? 'has-error' : ''">
            <label class="control-label" for="password">Email Address</label>
            <input type="email" name="email" class="form-control" placeholder="Email address" :value="$old.email" required autofocus>

            <span v-if="$errors.email" class="help-block">
                <strong>{{ $errors.email[0] }}</strong>
            </span>
        </div>
        <div class="form-group" :class="$errors.password ? 'has-error' : ''">
            <div class="u-flex u-flexAlignItemsCenter">
                <label class="control-label" for="password">Password</label>
                <div class="ml--auto">
                    <a href="/password/reset" class="forgot-password">
                        Forgot the password?
                    </a>
                </div>
            </div>
            <input type="password" name="password" class="form-control" placeholder="Password" required>

            <span v-if="$errors.password" class="help-block">
                <strong>{{ $errors.password[0] }}</strong>
            </span>
        </div>
        <div class="checkbox">
        </div>
        <div class="form-group">
            <button class="btn btn-primary btn-block btn-lg btn-signin" type="submit">Sign in</button>
        </div>

        <div class="text-center">
            <a href="#" @click.prevent="setLoginView('passwordless')">Parent Login</a>
        </div>
    </div>

</form><!-- /form -->
</template>

<script>
export default {
    props: ['form', 'loginUrl', 'tokenUrl', 'tokenIsInvalid', 'emailSent'],
    data: function () {
        console.log(localStorage.getPreferredLoginView);
        return {
            view: this.getPreferredView(),
        }
    },
    computed: {
        action() {
            return this.view == 'passwordless' ? this.tokenUrl : this.loginUrl
        }
    },
    methods: {
        setLoginView(view) {
            this.view = view;
            localStorage.getPreferredLoginView = this.view;
        },
        getPreferredView() {
            if (localStorage.getPreferredLoginView) {
                return localStorage.getPreferredLoginView;
            }

            return this.form;
        }
    }
}
</script>

<style>

</style>